var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconArena(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 373.635,
    height: 242.509,
    viewBox: "0 0 373.635 242.509",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{opacity:0.08;}.b{fill:#707070;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(-1125.765 -106.245)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1331.016,111.975l156.064,76.619L1286.791,281.15l-149.383-97.7,193.607-71.473m.292-5.73-2.12.783-193.6,71.481-9.823,3.625,8.763,5.73,149.375,97.7,2.449,1.6,2.65-1.229,200.288-92.556,10.038-4.639-9.932-4.877-156.064-76.619-2.028-1Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1286.214,223.66,1125.852,118.776v12.6l5.211,3.409,149.381,97.7,4.888,3.2,5.3-2.451,200.287-92.559,7.9-3.651V125.407Z",
    transform: "translate(0.578 83.711)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1264.362,213.191l-135.239-88.452v12.6l129.47,84.679,4.888,3.2,5.3-2.451,176.068-81.366V129.781Z",
    transform: "translate(22.431 123.543)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1216.031,112.292l-85.9,32.63,56,36.026,87.561-35.62Z",
    transform: "translate(29.194 40.394)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1200.256,170.441l79.037-32.152L1220.594,108,1142.429,137.7Z",
    transform: "translate(111.321 11.749)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1215.668,181.919h0l79.079-35.866-64.869-33.469-78.631,32.858Z",
    transform: "translate(170.222 42.348)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1226.057,117.333l-87.3,36.483,63.015,40.537,88.6-40.182Z",
    transform: "translate(86.76 74.073)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArena);
export default __webpack_public_path__ + "static/media/icon_arena.1e9abc2550ecd59060da0af766b927b2.svg";
export { ForwardRef as ReactComponent };